












































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ReportModule from '@/store/modules/Report';
import GameModule from '@/store/modules/Game';
import Table from '@/components/Table/Index.vue';
import HighValueReportBody from '@/components/Table/HighValueReportBody.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import MemberBody from '@/components/Table/MemberBody.vue';
import LogBody from '@/components/Table/LogBody.vue';
import Pagination from '@/components/Pagination.vue';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import DateRangeLogBody from '@/components/Table/DateRangeLog.vue';
import HighValueReportData from '@/data/HighValueReportData';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    MemberBody,
    LogBody,
    DateRangeLogBody,
    HighValueReportBody,
  },
})
export default class HighValueReportView extends Mixins(
  ToolMixin,
  ErrorHandleMixin,
  PaginationMixin,
) {
  ReportInstance = getModule(ReportModule, this.$store);

  GameInstance = getModule(GameModule, this.$store);

  DefaultGameList = [
    {
      name: 'All',
      value: 'total',
    },
  ];

  GameList: any = [];

  PaginationDetail = {
    amount: 0,
    current: 1,
    size: 100,
  };

  resultData: any = {};

  minBet = 1;

  multiplier = 50;

  Criteria = {
    ...this.Period,
    category: ['total'],
    minBet: this.minBet,
    multiplier: this.multiplier,
  };

  TableHeadHighValueReport: any = [...HighValueReportData.TableHeadHighValueReport];

  startDate = '';

  endDate = '';

  durationTime = '';

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  };

  created() {
    this.fetchHighValueReport();
    this.fetchGame();
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date).startOf('day').toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.endDate = _endDate;
  }

  initial() {
    this.minBet = 1;
    this.multiplier = 50;
    this.currentTool = 'Today';
    this.Criteria = {
      ...this.Period,
      category: ['total'],
      minBet: 1,
      multiplier: 50,
    };
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchHighValueReport();
  }

  handleCategory({ target: { checked, value } }) {
    if (value === 'total') {
      this.Criteria.category = checked ? this.GameList.map((item) => item.value) : [];
    } else if (value !== 'total') {
      if (checked) {
        this.Criteria.category.push(value);
        if (this.Criteria.category.length === this.GameList.length - 1) {
          this.Criteria.category.push('total');
        }
      } else {
        this.Criteria.category = this.Criteria.category.filter(
          (item) => item !== value && item !== 'total',
        );
      }
    }
  }

  async fetchHighValueReport() {
    const criteria = {
      ...this.Period,
      ...this.PaginationDetail,
      category: this.Criteria.category,
      minBet: Number(this.minBet),
      multiplier: Number(this.multiplier),
    };
    this.GeneralInstance.toggleLoading(true);

    const { data, status } = await this.ReportInstance.FetchHighValueReport(criteria);
    if (status) {
      this.checkError(status);
      this.GeneralInstance.toggleLoading(false);
    }
    this.resultData = data.result;
    this.PaginationDetail.size = 100;
    this.PaginationDetail.amount = data.totalPage;
    this.PaginationDetail.current = data.page;
  }

  async fetchResult(roundId: string) {
    const strWindowFeatures = `top=0,left=0,height=${750},width=${700},scrollbars=yes`;
    const param = {
      roundId,
      language: this.$i18n.locale,
    };
    const res = await this.ReportInstance.FetchTransaction(param);
    window.open(res.url, 'gameResult', strWindowFeatures);
  }

  async fetchGame() {
    const partner = {
      partner: 'all',
    };
    const res = await this.GameInstance.FetchGame(partner);
    if (res.code) {
      this.checkError(res);
    } else {
      await this.mapGameInput();
      this.Criteria.category = this.GameList.map((item) => item.value);
    }
  }

  @Watch('$i18n.locale')
  onLanguagChange() {
    if (this.$i18n.locale) {
      this.mapGameInput();
    }
  }

  async mapGameInput() {
    const games = await this.GameInstance.game.games
      .filter(
        (g) => g.name.en !== 'jump higher'
          && g.name.en !== 'Angpow'
          && g.status !== 999,
      )
      .map((g) => ({
        name: g.type.charAt(0).toUpperCase() + g.type.slice(1, g.type.length),
        value: g.type,
      }));
    let arr = Array.from(new Set(games.map((a) => a.value)))
      .map((type) => games.find((a) => a.value === type));
    arr = arr.filter((v) => v.value !== 'bonus');
    this.GameList = [...this.DefaultGameList, ...arr];
  }

  handleSearch() {
    this.PaginationDetail.current = 1;
    this.minBet = this.clampMinNumber(this.minBet, 0);
    this.multiplier = this.clampMinNumber(this.multiplier, 10);
    this.Criteria.minBet = this.minBet;
    this.Criteria.multiplier = this.multiplier;
  }

  clampMinNumber(value: unknown, min = 0): number {
    const n = typeof value === 'number' ? value : Number(value);
    if (Number.isNaN(n)) return min;
    return Math.max(min, n);
  }

  blockInvalidNumberKey(e: KeyboardEvent) {
    // Prevent typing scientific notation and negative/positive signs in number inputs.
    if (['e', 'E', '+', '-'].includes(e.key)) e.preventDefault();
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.fetchHighValueReport();
  }

  changeDate(Tool) {
    this.durationTime = '';
    this.handleTool(Tool.key);
  }

  onSubmit() {
    this.fetchHighValueReport();
  }
}
